const FINGERPRINT_STORAGE_KEY = 'envo_browser_fingerprint_v1';

function getCanvasFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    if (!context) return '';

    canvas.width = 240;
    canvas.height = 60;
    context.textBaseline = 'top';
    context.font = '16px Arial';
    context.fillStyle = '#f60';
    context.fillRect(0, 0, 120, 30);
    context.fillStyle = '#069';
    context.fillText('Envo browser fingerprint', 8, 8);
    context.fillStyle = 'rgba(102, 204, 0, 0.7)';
    context.fillText('Envo browser fingerprint', 10, 26);

    return canvas.toDataURL();
  } catch (error) {
    return '';
  }
}

function getWebglFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const gl =
      (canvas.getContext('webgl') ||
        canvas.getContext('experimental-webgl')) as WebGLRenderingContext | null;

    if (!gl) return '';

    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');

    if (!debugInfo) return '';

    return [
      gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL),
      gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL),
    ].join('|');
  } catch (error) {
    return '';
  }
}

function hashFingerprint(value: string) {
  let hash = 0x811c9dc5;

  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash +=
      (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }

  return `web_${(hash >>> 0).toString(16).padStart(8, '0')}`;
}

export function getBrowserFingerprint() {
  if (typeof window === 'undefined') return '';

  try {
    const cachedFingerprint = window.localStorage.getItem(
      FINGERPRINT_STORAGE_KEY,
    );

    if (cachedFingerprint) return cachedFingerprint;
  } catch (error) {}

  const { navigator, screen } = window;
  const signals = [
    navigator.userAgent,
    navigator.language,
    navigator.languages?.join(','),
    navigator.platform,
    navigator.hardwareConcurrency,
    (navigator as any).deviceMemory,
    screen.width,
    screen.height,
    screen.colorDepth,
    window.devicePixelRatio,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    getCanvasFingerprint(),
    getWebglFingerprint(),
  ];
  const fingerprint = hashFingerprint(signals.filter(Boolean).join('||'));

  try {
    window.localStorage.setItem(FINGERPRINT_STORAGE_KEY, fingerprint);
  } catch (error) {}

  return fingerprint;
}
